import apiGlobal from 'global/api.global';
import { RootState } from 'index';
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { Label, Row, Col } from 'reactstrap';

const VoyageAdjustment = () => {    /** State variables */
    const [tableDetails, setTableDetails] = useState({
        size: 4,
        index: 0,
        voyageAdjustment: []
    });
    const [count, setCount] = useState(0);
    const { VesselID } = useSelector((state: RootState) => state.Reporting);
    /** State variables end */

    /** useEffect start */
    useEffect(() => {
        loadData();
    }, [VesselID])
    /** useEffect end */

    /** Load N2 corrections of selected vessel that are already approved */
    const loadData = async () => {
        await apiGlobal.get(`vessel_reporting_cii_adjustment/get_cii_adjustment_record_with_fuel_by_vessel/?vessel_id=${VesselID}`).then(response => {
            setTableDetails(prevDetails => ({
                ...prevDetails,
                voyageAdjustment: response.data
            }));
            setCount(count => count + 1);
        }).catch(err => {
            setTableDetails(prevDetails => ({
                ...prevDetails,
                voyageAdjustment: []
            }));
        })
    };

    /** Pagination previous */
    const handlePrevPageClick = (e: any) => {
        tableDetails.index = (tableDetails?.index > 0) ? tableDetails?.index - 1 : 0;
        setCount(count + 1);
    }

    /** Pagination next */
    const handleNextPageClick = (e: any) => {
        tableDetails.index = (tableDetails?.index < (Math.ceil(tableDetails?.voyageAdjustment?.length / tableDetails?.size) - 1)) &&
            tableDetails?.index + 1
        setCount(count + 1);
    }

    return (
        <>
            {tableDetails?.voyageAdjustment?.length === 0 ? <Label>No N<sub>2</sub> corrections are approved for this vessel</Label> :
                <>
                    <Row className='mb-3'>
                        <Col lg={12}>
                            <div className="table-responsive">
                                <table className="table mb-0" key={count}>
                                    <thead className="table-light">
                                        <tr>
                                            <th>Sr. No.</th>
                                            <th>Adjustment</th>
                                            <th>Duration</th>
                                            <th
                                                colSpan={tableDetails?.voyageAdjustment[0]?.fuel_consumption?.length * 2}
                                                className='text-center'
                                            >
                                                Applicable Deduction
                                            </th>
                                        </tr>
                                        <tr>
                                            <th colSpan={3}></th>
                                            {tableDetails?.voyageAdjustment[0]?.fuel_consumption?.map((cii: any) => {
                                                return <th colSpan={2}>{cii?.fuel_sub_type_name}</th>
                                            })}
                                        </tr>
                                        <tr>
                                            <th colSpan={3}></th>
                                            {tableDetails?.voyageAdjustment[0]?.fuel_consumption?.map((cii: any) => {
                                                return (
                                                    <>
                                                        <th>Qty</th>
                                                        <th>CO<sub>2</sub> Emmission</th>
                                                    </>
                                                )
                                            })}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {tableDetails && tableDetails?.voyageAdjustment?.slice(tableDetails?.index * tableDetails?.size,
                                            tableDetails?.index * tableDetails?.size + tableDetails?.size)?.map((cii: any, index: number) => {
                                                return (
                                                    <tr>
                                                        <td>{index + 1}</td>
                                                        <td>{cii?.cii_adjustment_name}</td>
                                                        <td>
                                                            {cii?.cii_begin_date_time?.toString().substring(0, 10)}&nbsp;
                                                            {cii?.cii_begin_date_time?.toString().substring(11, 16)}&nbsp;&nbsp;to&nbsp;&nbsp;
                                                            {cii?.cii_end_date_time?.toString().substring(0, 10)}&nbsp;
                                                            {cii?.cii_end_date_time?.toString().substring(11, 16)}
                                                        </td>
                                                        {cii?.fuel_consumption?.map((fuel: any) => {
                                                            return (
                                                                <>
                                                                    <td>{fuel.fuel_consumption}</td>
                                                                    <td>Emmission</td>
                                                                </>
                                                            )
                                                        })}
                                                        <td></td>
                                                    </tr>
                                                )
                                            })
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </Col>
                    </Row>
                </>
            }
        </>
    )
}

export default VoyageAdjustment